<template>
	<div class="overflow-auto">
		<vue-good-table
			:line-numbers="true"
			:columns="columns"
			:rows="formattedRows"
			:sort-options="{
				enabled: true,
			}"
			:total-rows="totalRows"
			:pagination-options="paginationOptions"
			style-class="vgt-table vgt-responsive border-0 table"
			@on-sort-change="onSortChange"
			@on-page-change="onPageChange"
			@on-per-page-change="onPageChange"
		>
			<!-- Loading -->
			<div slot="emptystate" class="text-center font-size-14">No data available</div>

			<!-- Custom Rows -->
			<template slot="table-row" slot-scope="props" class="overflow-x" style="overflow-x: auto">
				<!-- Table Action -->
				<span v-if="props.column.field == 'action'">
					<b-dropdown id="dropdown-1" dropleft variant="primary" overflow="scroll" size="sm" class="m-md-2">
						<!-- <template #button-content>
        <span class="fe fe-menu"></span>
    </template> -->
						<b-dropdown-item
							class="dropdown-item-custom"
							v-if="!(props.row.status === 'Closed' || props.row.status === 'Early Termination') && canEdit"
							@click="updateData(props.row)"
						>
							Edit
						</b-dropdown-item>
						<b-dropdown-item class="dropdown-item-custom" @click="viewsDetails(props.row.id)"> View Detail </b-dropdown-item>
						<b-dropdown-item
							class="dropdown-item-custom"
							v-if="(props.row.status == 'On Going' || props.row.status == 'Draft') && canDelete"
							@click="deleteData(props.row.id)"
						>
							Delete
						</b-dropdown-item>
						<b-dropdown-item
							v-if="canEdit && ['On Going', 'Expired Soon', 'Expired', 'Value Warning', 'Closed'].includes(props.row.status)"
							class="dropdown-item-custom"
							@click="sendNotification(props.row)"
						>
							Send Notification
						</b-dropdown-item>
						<b-dropdown-item
							v-if="
								type != 'closed' &&
								canEdit &&
								['On Going', 'Expired Soon', 'Expired', 'Value Warning', 'Closed'].includes(props.row.status)
							"
							class="dropdown-item-custom"
							@click="amendContract(props.row)"
						>
							Amendment
						</b-dropdown-item>
						<b-dropdown-item
							class="dropdown-item-custom"
							:to="{
								name: `HistoricalLog`,
								params: {
									id: props.row.id,
									data: props.row,
								},
							}"
						>
							Historical Log
						</b-dropdown-item>
						<b-dropdown-item
							class="dropdown-item-custom"
							v-if="type == 'closed' && canEdit"
							@click="downloadData(props.row.id, props.row.name)"
						>
							Download
						</b-dropdown-item>
					</b-dropdown>
				</span>
				<span v-else-if="props.column.field == 'status'">
					<div class="row g-0">
						<div class="col">
							<h2>
								<span v-if="props.row.status == 'Early Termination'" :class="getStatusClass(props.row.status)">
									Early Terminated
								</span>
								<span v-if="props.row.status == 'Closed'" :class="getStatusClass(props.row.status)"> Closed </span>
								<span v-if="props.row.status == 'On Going'" :class="getStatusClass(props.row.status)"> On Going </span>
								<span v-if="props.row.status == 'Expired Soon'" :class="getStatusClass(props.row.status)"> Expired Soon </span>
								<span v-if="props.row.status == 'Expired'" :class="getStatusClass(props.row.status)"> Expired </span>
								<span v-if="props.row.status == 'Draft'" :class="getStatusClass(props.row.status)"> Draft </span>
							</h2>
						</div>
						<div class="col" v-if="props.row.value_warning">
							<h2>
								<span :class="getStatusClass('Value Warning')"> Value Warning </span>
							</h2>
						</div>
					</div>
				</span>
				<span v-else-if="props.column.field == 'name'">
					<span
						:id="'tooltip-name-' + props.row.id"
						class="contract-name-cell"
						style="max-width: 200px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
					>
						{{ props.row.name }}
					</span>
					<b-tooltip :target="'tooltip-name-' + props.row.id" placement="right" triggers="hover" variant="dark">
						{{ props.row.name }}
					</b-tooltip>
				</span>
				<span v-else-if="props.column.field == 'budget_gl'">
					<span
						:id="'tooltip-budget-gl-' + props.row.id"
						class="contract-budget-gl-cell"
						style="max-width: 260px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
					>
						{{ props.row.budget_gl }}
					</span>
					<b-tooltip :target="'tooltip-budget-gl-' + props.row.id" placement="right" triggers="hover" variant="dark">
						{{ props.row.budget_gl }}
					</b-tooltip>
				</span>
				<span v-else-if="props.column.field == 'scope_of_work'">
					<span
						:id="'tooltip-sow-' + props.row.id"
						class="contract-sow-cell"
						style="max-width: 200px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
					>
						{{ props.row.scope_of_work }}
					</span>
					<b-tooltip :target="'tooltip-sow-' + props.row.id" placement="right" triggers="hover" variant="dark">
						{{ props.row.scope_of_work }}
					</b-tooltip>
				</span>
				<span v-else-if="props.column.field == 'updated_at'">
					{{ formatedDate(props.row.updated_at) || '-' }}
				</span>
				<span v-else-if="props.column.field == 'closed_at' || props.column.field == 'terminated_at'">
					{{ formatedDate(props.row.activity?.[0]?.created_at) || '-' }}
				</span>
				<span v-else-if="props.column.field == 'expired_at'">
					{{ formatedDate(props.row.end_date) || '-' }}
				</span>
			</template>
		</vue-good-table>
	</div>
</template>

<script>
	import { props } from 'vue2-dropzone';
	import { indonesianCalendar } from '@/utils/common';
	import { authorize } from '@/utils/authorize';

	export default {
		name: 'MyContract',
		props: ['list', 'columns', 'totalRows', 'type', 'currentPage', 'perPage'],
		computed: {
			formattedRows() {
				return this.list?.map((row) => ({
					...row,
					budget_gl: row.list_budget_gl?.[0]?.budget_gl || '-', // Flatten nested budget_gl
				}));
			},
			paginationOptions() {
				return {
					enabled: true,
					mode: 'pages',
					position: 'bottom',
					perPage: this.perPage,
					perPageDropdown: [5, 10, 50, 100],
					dropdownAllowAll: false,
					setCurrentPage: this.currentPage,
					nextLabel: 'next',
					prevLabel: 'prev',
					rowsPerPageLabel: 'Rows per page',
					ofLabel: 'of',
					pageLabel: 'page',
					allLabel: 'All',
				};
			},
		},
		data() {
			return {
				role_id: localStorage.getItem('role_id'),
				canAdd: false,
				canEdit: false,
				canDelete: false,
			};
		},

		async mounted() {
			this.canAdd = await authorize('/listContract', 'create');
			this.canEdit = await authorize('/listContract', 'update');
			this.canDelete = await authorize('/listContract', 'delete');
		},
		methods: {
			getStatusClass(status) {
				if (status === 'On Going') {
					return 'badge bg-green align-items-center badge-lg';
				} else if (status === 'Closed') {
					return 'badge bg-red align-items-center badge-lg';
				} else if (status === 'Early Termination') {
					return 'badge bg-dark align-items-center badge-lg';
				} else if (status === 'Expired Soon') {
					return 'badge bg-yellow align-items-center badge-lg';
				} else if (status === 'Expired') {
					return 'badge bg-pink align-items-center badge-lg';
				} else if (status === 'Value Warning') {
					return 'badge bg-orange align-items-center badge-lg';
				} else if (status === 'Draft') {
					return 'badge bg-gray align-items-center badge-lg';
				}
			},
			onPageChange(param) {
				this.$emit('onPageChange', param);
			},
			onSortChange(param) {
				this.$emit('onSortChange', param);
			},
			updateData(data) {
				this.$emit('updateData', data);
			},
			amendContract(data) {
				this.$emit('amendContract', data);
			},
			sendNotification(data) {
				this.$emit('sendNotification', data);
				console.log(data);
			},
			detailData(data) {
				this.$emit('detailData', data);
			},
			deleteData(data) {
				this.$emit('deleteData', data);
			},
			downloadData(id, name) {
				this.$emit('downloadData', id, name);
			},
			viewsDetails(id) {
				this.$store.commit('listContract/RESET_DETAIL_TERM');
				this.$router.push(`/listContract/${id}/details`);
			},
			formatedDate(date) {
				return indonesianCalendar(date, true) || '-';
			},
		},
	};
</script>
<style>
	.badge-lg {
		margin-bottom: -17px;
	}

	.badge.bg-green {
		background-color: #2ecc71;
	}

	.badge.bg-pink {
		background-color: #fd9596;
	}

	.badge.bg-red {
		background-color: #ff0000;
	}

	.badge.bg-dark {
		background-color: #333333;
	}

	.badge.bg-yellow {
		background-color: #f1c40f;
	}

	.badge.bg-orange {
		background-color: #e67e22;
	}

	.badge.bg-gray {
		background-color: #999999;
	}

	.dropdown-item-custom {
		font-size: 12px;
	}

	.dropdown-item-custom:hover {
		background-color: #00000052;
	}

	.vgt-inner-wrap {
		min-width: 100% !important;
	}

	.vgt-responsive {
		min-height: 200px !important;
	}
</style>
